var exports = {
  "k": "xe564cbfb--f15251--container",
};

module.exports = exports;
